// One shared store for the Classes & Instructors admin page.
//
// Both the Class tab and the Instructor tab read from THIS hook, so a change
// made on either card re-renders both views from the same canonical
// instructor_class_assignments rows. Realtime keeps other open tabs in sync.
import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import {
  fetchStaffingData,
  type StaffingData,
} from "@/lib/staffing";

const EMPTY: StaffingData = { classes: [], instructors: [], assignments: [], periods: [] };

export function useStaffingBoard() {
  const [data, setData] = useState<StaffingData>(EMPTY);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const next = await fetchStaffingData();
    setData(next);
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
    const ch = supabase
      .channel(`staffing-board-${crypto.randomUUID()}`)
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "instructor_class_assignments" },
        () => refresh(),
      )
      .on("postgres_changes", { event: "*", schema: "public", table: "classes" }, () => refresh())
      .on("postgres_changes", { event: "*", schema: "public", table: "instructors" }, () =>
        refresh(),
      )
      .subscribe();
    return () => {
      supabase.removeChannel(ch);
    };
  }, [refresh]);

  return { ...data, loading, refresh };
}
